export const NavbarSkeleton = () => {
  // Create array with 8 elements to simulate menu items (matching the actual nav items count)
  const skeletonItems = Array(8).fill(null);

  return (
    <>
      {/* Desktop Sidebar Navigation Skeleton */}
      <div className=" hidden [@media(min-width:900px)]:block fixed left-0 top-12 bottom-0 w-64 bg-white border-r border-[#E5E7EB] z-0 [@media(min-width:1921px)]:left-[calc((100%-1920px)/2)]">
        <div className="h-full overflow-y-auto pt-2">
          <div className="px-4 py-2 space-y-1">
            {skeletonItems.map((_, index) => (
              <div
                key={index}
                className="flex items-center w-full px-4 py-3 rounded-xl bg-gray-50"
              >
                <div className="w-5 h-5 rounded-md bg-gray-200 animate-pulse"></div>
                <div className="ml-3 h-4 w-28 bg-gray-200 rounded-md animate-pulse"></div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Content Area Skeleton */}
      <div className="[@media(min-width:900px)]:ml-64 p-6"></div>

      {/* Mobile Bottom Navigation Skeleton */}
      <div className="[@media(min-width:900px)]:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-[#E5E7EB]">
        <div className="flex justify-around items-center h-16 px-2">
          {[...Array(5)].map((_, index) => (
            <div key={index} className="flex flex-col items-center space-y-1">
              <div className="w-5 h-5 rounded-md bg-gray-200 animate-pulse"></div>
              <div className="h-3 w-14 bg-gray-200 rounded-md animate-pulse"></div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
